import { Autocomplete, Box, Button, createMuiTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Modal, Switch, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react'
import DropdownTreeSelect from 'react-dropdown-tree-select';
import { GuardarNuevoActivo, GuardarNuevoTipoActivo, ObtenerArbolActivos, ObtenerTiposActivo } from '../../helpers/ActivosHelper';
import { GuardarAvance, GuardarNuevoAsunto, ObtenerPrioridades } from '../../helpers/AsuntosHelper';
import { ObtenerUsuarios } from '../../helpers/UsuariosHelper';
import { AsuntosContext } from '../../pages/asuntos/AsuntosPage';
import { ActivosContext } from '../../pages/catalogos/ActivosPage';
import { TiposActivoContext } from '../../pages/catalogos/ActivosTipoPage';
import { AuthContext } from '../../context/AuthContext';

import "react-dropdown-tree-select/dist/styles.css";
import "../../pages/asuntos/AsuntosStyle.css";
import { ModalInstalacionComponent } from './ModalInstalacionComponent';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalAgregaAvanceComponent = () => {
    const {modalAgregaAvance, setModalAgregaAvance, instalacionSeleccionada, setInstalacionSeleccionada,modalSeleccionInstalacion, setModalSeleccionInstalacion, obtenerAsuntos, agregandoTarea, setAgregandoTarea, asuntoSeleccionado, tareaSeleccionada} = useContext(AsuntosContext)
    const {usuario} = useContext(AuthContext)
    const [errorGuardado, setErrorGuardado] = useState(false);
    const [datosAvance, setDatosAvance] = useState({'idUsuario':usuario.IdUsuario})
    const [responsables, setResponsables] = useState([]);
    const [prioridades, setPrioridades] = useState([]);
    const [instalaciones, setInstalaciones] = useState();
    const [tituloInstalacion, setTituloInstalacion] = useState();
    const [tiposServicio, setTiposServicio] = useState();
    const refForm = useRef();
    console.log('Valor de agregando tarea', agregandoTarea, asuntoSeleccionado);

    const handleClose = () => {
      setDatosAvance({'idUsuario':usuario.IdUsuario});
        setModalAgregaAvance(false);
    }

    useEffect(() => {
      console.log('selecciono instalacion', instalacionSeleccionada)
      actualizaDatos('idInstalacion',instalacionSeleccionada?.value)
    }, [instalacionSeleccionada])
    

    const obtenerInstalaciones =() => {
      ObtenerArbolActivos().then(datos=>setInstalaciones(datos));
    }       


    const handleSubmit =  async(event) => {
  //      await actualizaDatos('idPadre', activoSeleccionado?.key);
        event.preventDefault();
        //refForm.current.isValidate();
        let idAsunto = 0;
        if(tareaSeleccionada?.IdAsunto) {
         idAsunto = tareaSeleccionada?.IdAsunto;
        } else {
          idAsunto = asuntoSeleccionado?.IdAsunto;
        }
        GuardarAvance(idAsunto,datosAvance?.descripcion,usuario.IdUsuario,datosAvance?.porcentajeAvance,instalacionSeleccionada?.value).then(respuesta => {
            console.log('respuesta de guardado en modal', respuesta);
            if(respuesta!=1) {
                setErrorGuardado(true);
            } else{
                setErrorGuardado(false);
                obtenerAsuntos();
                handleClose();

            }
        })
    }


    const actualizaDatos = (dato, valor) => {
      setDatosAvance({
          ...datosAvance,
          [dato]:valor
      })
    }

    function onChange(currentNode, selectedNodes) {
      // currentNode: { label, value, children, expanded, checked, className, ...extraProps }
      // selectedNodes: [{ label, value, children, expanded, checked, className, ...extraProps }]
      console.log('cambio el nodo',currentNode);
      setTituloInstalacion(currentNode?.title)
      actualizaDatos('idInstalacion', currentNode.value)
    }    

 
    // useEffect(() => {
    //   console.log('datos activo', datosActivo);
    // }, [datosActivo])

    useEffect(() => {
      obtenerInstalaciones();
      console.log('instalacion seleccionada de tarea', tareaSeleccionada, asuntoSeleccionado)
      if(tareaSeleccionada?.IdAsunto) {
        setInstalacionSeleccionada({
          'title':tareaSeleccionada?.Ruta+'>'+tareaSeleccionada?.Descripcion,
          'value':tareaSeleccionada?.IdInstalacion
        })
      } else {
        setInstalacionSeleccionada({
          'title':asuntoSeleccionado?.Ruta+'>'+asuntoSeleccionado?.Descripcion,
          'value':asuntoSeleccionado?.IdInstalacion
        })

      }


    }, [])
    
    useEffect(() => {
      if(agregandoTarea) {
        console.log('asunto seleccionado para agregar tarea', asuntoSeleccionado)
        actualizaDatos('idAsuntoPadre',asuntoSeleccionado.IdAsunto)
        setInstalacionSeleccionada({
          'title':asuntoSeleccionado.Ruta,
          'value':asuntoSeleccionado.IdInstalacionPadre
        })
      }
    }, [agregandoTarea])
    

    useEffect(() => {
      console.log('datos asunto', datosAvance)
    }, [datosAvance])
    

  return (
    <>
      <div
        style={{
            minWidth:600, minHeight:800
        }}
    >
     <Dialog open={modalAgregaAvance} onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={refForm}>
        <DialogTitle>
          <Typography
            style={{
              fontSize:'1.25rem',
              fontWeight:'500'
            }}
          >
                 <>Agregar Avance</>
          </Typography>
 
        </DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          <Button
            onClick={() => {
              setModalSeleccionInstalacion(true);
            }}
          >Seleccionar instalación</Button>
          <Typography>
            {instalacionSeleccionada?.title || 'Da click en Seleccionar Instalación'}
          </Typography>
          <TextField
            margin="dense"
            id="name"
            multiline={true}
            rows={3}
            name="txtTipoActivo"
            label="Descripción"
            type="text"

            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => actualizaDatos('descripcion', e.target.value)}
         //   value={datosAvance?.descripcion}
          />
          <TextField
            margin="dense"
            id="name"
            multiline={false}
            rows={3}
            name="txtTipoActivo"
            label="% Avance"
            type="number"
            InputProps={{ inputProps: { min: 0, max: 100 } }}
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => actualizaDatos('porcentajeAvance', e.target.value)}
         //   value={datosAvance?.descripcion}
          />
          {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type='submit' >Guardar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
    <ModalInstalacionComponent />
    </>
  )
}
